import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPhotos = photos => ({
  type: actionTypes.SET_AD_PHOTOS,
  payload: photos
})
